import React, { Component } from 'react'

import { assetUrl } from '../../../config';
import AutoVideo from '../../AutoVideo';
import $ from 'jquery';
import { withT } from '../../../i18n';
class PsychotropicColony extends Component {
    server_path = window.src_path;
    constructor() {
        super()
    }

    loadInitJs() {
        /* var item_name = this.pr */
        /* console.log(item_name); */
    }
    componentDidMount() {
        this.loadInitJs();
    }
    render() {
        const { t } = this.props;
        return (
            <>
                <div className="portfolio__main">
                    <div className="wrapper">
                        <div className="portfolio__inner">
                            <div className="left__panel">
                                <div className="image_div">
                                    <AutoVideo controls src={assetUrl('collection/topslide/The-Psychotropic-Colony.mp4')} poster={assetUrl('collection/topslide/The-Psychotropic-Colony.jpg')} aria-label="The Psychotropic Colony"></AutoVideo>
                                </div>
                            </div>
                            <div className="right__panel">
                                <h2 className="heading">The Psychotropic Colony</h2>

                                <h2 className="artist_name"><span>{t('work.by')} </span> GMUNK </h2>
                                <div className="desc">
                                    <p>The Psychotropic Colony is the Engine of Qualia Diversity – the phenomenon which uses multiple optimization points to converge on invariance, which hint at the range of possible experiences in the Qualia state space opening up beyond.</p></div>

                                <a href="https://opensea.io/assets/0xb932a70a57673d89f4acffbe830e8ed7f75fb9e0/17515" className="css_btn"><span>{t('work.viewArtwork')}</span></a>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        )
    }
}

export default withT(PsychotropicColony);
